export const accordionStatic = (descrSelector, btnSelector, wrapperSelector) => {

    const descriptions = document.querySelectorAll(descrSelector);
    const btnsToggle = document.querySelectorAll(btnSelector);
    const wrappers = document.querySelectorAll(wrapperSelector);

    wrappers.forEach((wrapper, i) => (
        wrapper.addEventListener('click', () => {
            descriptions[i].classList.toggle('showDescr');
            btnsToggle[i].classList.toggle('active');
        })
    ));
};

export const accordionDinamic = (materealsArr, wrapperSelector, descrSelector, btnSelector, titleSelector) => {
    const wrappers = document.querySelectorAll(wrapperSelector);

    materealsArr.forEach((matereal, i) => {
        const descr = document.createElement('div');
        descr.classList.add(descrSelector.slice(1));
        descr.innerHTML = `
            <p>${matereal.descr}</p>
        `

        const wrapper = wrappers[i];
        if (wrapper) {
            wrapper.insertAdjacentElement('afterend', descr);
        } else {
            console.error(`Элемент wrapper с индексом ${i} не найден.`)
        }
    });

    const titlesToggle = document.querySelectorAll(titleSelector),
          btnsToggle = document.querySelectorAll(btnSelector),
          descriptions = document.querySelectorAll(descrSelector);

    if (titlesToggle.length === btnsToggle.length && descriptions.length) {
        const showDescr = (i) => {
            btnsToggle[i].classList.toggle('active');
            descriptions[i].classList.toggle('showDescr');
        };
        wrappers.forEach((wrapper, i) => {
            wrapper.addEventListener('click', () => showDescr(i));
        });
    } else {
        console.log(titlesToggle);
        console.log(btnsToggle)
        console.error('Количество элементов не совпадает')
    }
};
